<!--
     <DirectoryInput
       :props="my_attrs_dictionary"
     />

     Public propertys:
       value → Gives the field's serializable value

     Public methods:
       validate → Makes validation and returns if the value is valid

     Accepted props:
     - label
     - readonly
-->

<template>
  <v-container fluid class="pa-0 mb-5">
    <v-row>
      <v-col
        style="font-size: 16px"        
      >
        <v-subheader :class="['qmkey-form-input', {'required':props.required}]">
          <label>{{ props.label || $vuetify.lang.translator('inputs.directory')+':' }}</label>
        </v-subheader>
        <ExplorerDirectoryPath
          v-if="props.readonly || props.disabled"
          class="ml-4"
          :path="path"
          :disabled="props.disabled"
        />
        <ExplorerDirectoryPathEditable
          v-if="!props.readonly && !props.disabled"
          class="ml-4"
          :centro_id="centro_id"
          :path="path"
          @edit="update_path"
          :props="props"
        />
      </v-col>
    </v-row>
  </v-container>
</template>


<script>
 import { mapGetters, mapState } from 'vuex'
 import ExplorerDirectoryPath from '@/components/explorer/ExplorerDirectoryPath'
 import ExplorerDirectoryPathEditable from '@/components/explorer/ExplorerDirectoryPathEditable'

 export default {
   name: 'DirectoryInput',

   components: {
     ExplorerDirectoryPath,
     ExplorerDirectoryPathEditable,
   },

   props: [
     'props',
     'required_rule',
   ],

   data: (() => ({
     target_id: null,
   })),

   mounted() {
     this.update_path(this.props.value || this.activeDirectory.id);     
   },

   computed: {
     ...mapGetters({
       default_centro_id: 'centro_id',
     }),

     ...mapState([
       'activeDirectory',
       'qdirectory'
     ]),

     centro_id() {
       if (this.props.current_unit !== undefined && this.props.current_unit !== null) {
         return this.props.current_unit.centro;
       } else {
         return this.default_centro_id;
       }
     },

     path() {
       return (this.qdirectory[this.target_id] || {}).path || [];
     },

     value() {
       return this.target_id;
     },
   },

   methods: {
     validate() {
       return true;
     },

     update_path(dir_id) {
       this.target_id = dir_id;
       this.$emit('update', dir_id)
     },
   },

   watch: {
     props(p) {
       this.target_id = this.props.value || this.activeDirectory.path;
     },
   }
 }
</script>
